import React, { useState, useEffect } from "react";
import { Row, Col, Card, Typography, message, Divider, Table, Input, Space, Select, Spin } from "antd";
import { SearchOutlined, FileDoneOutlined, LoadingOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import http from "../../../services/http";
const { Text } = Typography;
const antIcon = <LoadingOutlined style={{ fontSize: 18 }} spin />;
const optionsFiltro = [
  { value: 0, label: "Todos" },
  { value: 1, label: "Marcados" },
  { value: 2, label: "Não Marcados" },
];

export const TermosCargos = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // DADOS
  const [dados, setDados] = useState([]);
  const [selected, setSelected] = useState([]);

  // FILTRO
  const [marcado, setMarcado] = useState(0);
  const [search, setSearch] = useState("");

  // DADOS TERMO
  const [termo, setTermo] = useState({});

  useEffect(() => {
    if (id) {
      carregarTermo(id);
      listarCargos(id);
    }
  }, [id]);

  // CARREGAR TERMO
  const carregarTermo = async (id_termo) => {
    if (!id_termo) return;
    setLoading(true);
    const api = await http("get", `v1/termos/carregar/${id_termo}`, []);
    if (api.statusCode === 200) {
      if (!api.response.data) {
        navigate("/termos/cadastro");
      }
      setTermo(api.response.data);
    } else {
      message.error(api.response.message);
      navigate("/termos/cadastro");
    }
    setLoading(false);
  };

  // LISTAR CARGOS
  const listarCargos = async (id_termo) => {
    if (!id_termo) return;
    setLoading(true);
    const api = await http("get", `v1/termos_cargos/listar/${id_termo}`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data.data);
      setSelected(api.response.data.checked);
    } else {
      message.error(api.response.message);
      navigate("/termos/cadastro");
    }
    setLoading(false);
  };

  // SALVAR CARGOS
  const salvarCargos = async (cargos_selected, termos, idTermo) => {
    setLoading(true);

    let array_termos = [];
    termos &&
      termos.map((e) => {
        array_termos.push(e.key);
      });

    const dados_envio = {
      id_cad_termos_ciencia: idTermo,
      id_termos_cargos: array_termos,
      id_termos_cargos_checked: cargos_selected,
    };

    const api = await http("post", `v1/termos_cargos/adicionar`, dados_envio);
    if (api.statusCode === 200) {
      setSelected((array) =>
        array.filter(function (x) {
          return array_termos.indexOf(x) < 0;
        })
      );
      setSelected((val) => [...val, ...cargos_selected]);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // COLUNAS TABLE
  const columns = [
    {
      title: (
        <div style={{ height: 23 }}>
          Cargo <Spin indicator={antIcon} spinning={loading} />
        </div>
      ),
      dataIndex: "cargo",
      sorter: (a, b) => a.cargo?.localeCompare(b.cargo),
    },
  ];

  // PESQUISAR
  const handleFilter = (pesquisar, marcado) => {
    let filteredData = dados?.filter((val) => val.cargo?.toLowerCase().includes(pesquisar.toLowerCase()));

    switch (marcado) {
      case 1:
        filteredData = filteredData.filter((e) => {
          return selected.indexOf(e.id) === -1 ? false : true;
        });
        break;
      case 2:
        filteredData = filteredData.filter((e) => {
          return selected.indexOf(e.id) === -1 ? true : false;
        });
        break;
      default:
        break;
    }

    return filteredData;
  };

  const dadosFilter = dados?.length > 0 ? handleFilter(search, marcado) : [];

  // CHECK ROW
  const rowSelection = {
    type: "checkbox",
    disabled: true,
    selectedRowKeys: selected,
    onSelectAll: (e) => {
      if (loading) return;
      let array = [];
      if (e === true) array = dadosFilter.map((e) => e.key);
      salvarCargos(array, dadosFilter, id);
    },
    onSelect: (data, status) => {
      if (loading) return;
      salvarCargos(status ? [data.key] : [], [{ key: data.key }], id);
    },
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Configurações" onClickBack={() => navigate("/termos/cadastro")} />
            <HeaderTitle
              title="Termo Cargos"
              subtitle={
                <Text italic>
                  <FileDoneOutlined /> {termo?.descricao ?? ""}
                </Text>
              }
              icon={<CheckCircleOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space direction="vertical">
                <Space wrap>
                  <Input
                    size="middle"
                    maxLength={100}
                    prefix={<SearchOutlined />}
                    className="input"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Pesquisar..."
                    allowClear
                  />
                  <Select
                    defaultValue={0}
                    value={marcado}
                    style={{ width: 180, maxWidth: "100%" }}
                    onChange={(e) => setMarcado(e)}
                    options={optionsFiltro}
                  />
                </Space>
              </Space>

              <Divider />

              <Table
                loading={loading}
                scroll={{ x: 700 }}
                columns={columns}
                rowSelection={rowSelection}
                dataSource={dadosFilter}
                size="small"
              />
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};
